import type { FacebookLoginErrorResponse, FacebookLoginRequest } from '~/types/on24-klient'
import type { FetchError } from 'ofetch'
import * as t from '~/messages'
import { useOAuthPopup } from '~/composables/oauth-popup'

export const useFacebookLogin = () => {
  if (!import.meta.client) {
    return { login() {} }
  }

  const errorStore = useLoginErrorStore()
  const loginReturnTo = useLoginReturnTo()

  const popup = useOAuthPopup()

  const login = () =>
    popup.open(
      '/auth/facebook',
      async (token) => {
        try {
          await $fetch<undefined>('/api/login/facebook', {
            method: 'POST',
            body: {
              accessToken: token,
            } satisfies FacebookLoginRequest,
          })

          await loginReturnTo.redirectFromLogin()
          return
        } catch (error) {
          const loginResponseData = error as FetchError<FacebookLoginErrorResponse>

          if (loginResponseData.data) {
            if (loginResponseData.data.type === 'LOGIN_ERROR') {
              errorStore.setLoginErrorMessage(t['w.login.fb.error.generic_login']())
              await loginReturnTo.navigateToLogin()
              return
            } else if (loginResponseData.data.type === 'REGISTER_ERROR_MISSING_EMAIL') {
              errorStore.setRegisterErrorMessage(t['w.login.fb.error.missing_email']())
              await navigateTo('/register')
              return
            }
          }
        }
      },
      async () => {
        errorStore.setLoginErrorMessage(t['w.login.fb.error.generic_login']())
        await loginReturnTo.navigateToLogin()
      }
    )

  return { login }
}
